interface ConfigInterface {
  quickTravelUrl: string;
  STGUrl: string;
}

const Config: ConfigInterface = {
  quickTravelUrl: process.env.REACT_APP_QUICK_TRAVEL_URL || '',
  STGUrl: process.env.REACT_APP_STG_URL || '',
};

export default Config;
